import PropTypes from 'prop-types';

export default function List({ items, useCheckmarks = false }) {
	const classes = ['list'];
	useCheckmarks && classes.push('list--checkmark');

	return (
		<ul className={classes.join(' ')}>
			{items.map((item, index) => (
				<li className={item?.highlight_element ? 'list__item--highlight' : ''} key={index} dangerouslySetInnerHTML={{ __html: item.name }} />
			))}
		</ul>
	);
}

List.propTypes = {
	items: PropTypes.array.isRequired,
	useCheckmarks: PropTypes.bool,
};
